import ActivityTypesService from './activityTypesService';

const ActivitiesService = {

  parseActivity: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      activityType: ActivityTypesService.parseActivityType(response._embedded['dm:activity_type:v1']),
      calories: response.calories,
      distance: response.distance,
      duration: response.duration,
      felt: response.felt,
      intensity: response.intensity,
      completedAt: new Date(response.completed_at),
      _links: response._links,
      _forms: response._forms
    };
  }

};

export default ActivitiesService;



// WEBPACK FOOTER //
// ./src/api/services/activitiesService.js